import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import localeEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeEs, 'es');

import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerModule } from 'ngx-spinner';

import { CustomDateFormatter } from '@app/core/dates/custom-date.formatter';
import { LoaderInterceptor } from '@core/interceptor/loader.interceptor';
import { ErrorInterceptor } from '@core/interceptor/error.interceptor';
import { AuthInterceptor } from '@core/interceptor/auth.interceptor';
import { CustomDateAdapter } from '@core/dates/custom-date.adapter';
import { NoAuthGuard } from '@core/guards/no-auth.guard';
import { AuthGuard } from '@core/guards/auth.guard';

@NgModule({ declarations: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        NgxSpinnerModule
    ], imports: [NgxSpinnerModule,
        BrowserAnimationsModule,
        SweetAlert2Module.forRoot()], providers: [
        AuthGuard,
        NoAuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: NgbDateParserFormatter,
            useValue: new CustomDateFormatter("YYYY-MM-DD") // <== formato!
        },
        {
            provide: NgbDateAdapter,
            useClass: CustomDateAdapter
        },
        {
            provide: LOCALE_ID,
            useValue: 'es'
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule { }
